/**
 * Expand/collapse control that spreads a page to full width and back.
 * Mirrors the analysis page's full-width toggle, themed for the perf pages.
 */
export default function FullWidthToggle({ isFullWidth, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 hover:border-slate-400 transition-colors focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
      title={isFullWidth ? "Collapse to normal width" : "Expand to full width"}
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        {isFullWidth ? (
          // Collapse icon (arrows pointing inward)
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          />
        ) : (
          // Expand icon (arrows pointing outward)
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
          />
        )}
      </svg>
      {isFullWidth ? "Collapse" : "Expand"}
    </button>
  );
}
